import { Link } from 'react-router-dom-v5-compat';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

import { UnauthenticatedPageContentLayout } from 'src/components/UnauthenticatedPageContentLayout';
import { ROUTES } from 'src/routes';

export const UnauthenticatedPageErrorLayout = ({ className, title, subtitle }) => {
  return (
    <UnauthenticatedPageContentLayout className={className} title={title} subtitle={subtitle}>
      <Button
        component={Link}
        to={ROUTES.SIGN_UP}
        variant="contained"
        color="primary"
        fullWidth
        size="large"
      >
        Create a new free account
      </Button>
    </UnauthenticatedPageContentLayout>
  );
};

UnauthenticatedPageErrorLayout.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

UnauthenticatedPageErrorLayout.defaultProps = {
  className: null,
  title: null,
  subtitle: null,
};
